import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-attendance',
  templateUrl: './admin-attendance.component.html',
  styleUrls: ['./admin-attendance.component.scss']
})
export class AdminAttendanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
